/* Mae & Rose cart motion: feedback while a cart line updates.
 * - qty -/+ : the line's stepper + price dim until the cart answers
 * - trash (or - at 1 on the last line): spinner on the trash, row slides out, then the empty state fades in
 * Listens on window (capture) so it runs before the theme's own document-level handlers. */
(() => {
  if (window.__mrCartMotion) return;
  window.__mrCartMotion = true;

  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const LEAVE_MS = 380;

  const lineOf = (row) => {
    const btn = row && row.querySelector('.cart-items__remove');
    const m = btn && (btn.getAttribute('on:click') || '').match(/onLineItemRemove\/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  };

  const clearBusy = (comp) => comp.querySelectorAll('.mr-busy').forEach((r) => r.classList.remove('mr-busy'));

  // When the cart stops being "disabled" the request is done: undim everything.
  const watched = new WeakSet();
  const watch = (comp) => {
    if (watched.has(comp)) return;
    watched.add(comp);
    new MutationObserver(() => {
      if (!comp.classList.contains('cart-items-disabled')) clearBusy(comp);
    }).observe(comp, { attributes: true, attributeFilter: ['class'] });
  };

  const leaveThenRemove = (comp, row, line, trash) => {
    if (trash) trash.classList.add('mr-spin');
    row.style.setProperty('--mr-row-h', `${row.offsetHeight}px`);
    row.classList.add('mr-leaving');
    setTimeout(() => {
      comp.onLineItemRemove(line);
      // the empty state is swapped in synchronously or inside a view transition: tag it as soon as it exists
      let n = 0;
      const tag = () => {
        const c = comp.querySelector('.cart-drawer__content, .cart-items__empty, [class*="empty"]');
        if (c && !comp.querySelector('.cart-items__table-row[data-key]')) c.classList.add('mr-fade-in');
        else if (n++ < 20) requestAnimationFrame(tag);
      };
      tag();
    }, LEAVE_MS);
  };

  window.addEventListener(
    'click',
    (e) => {
      const el = e.target instanceof Element ? e.target : null;
      if (!el) return;
      const comp = el.closest('cart-items-component');
      if (!comp) return;
      watch(comp);
      const row = el.closest('.cart-items__table-row');
      if (!row) return;

      const trash = el.closest('.cart-items__remove');
      const minus = el.closest('.quantity-minus');
      const plus = el.closest('.quantity-plus');
      if (!trash && !minus && !plus) return;
      if (row.classList.contains('mr-leaving') || comp.classList.contains('cart-items-disabled')) return;

      const input = row.querySelector('.quantity-selector input');
      const qty = input ? parseInt(input.value, 10) || 0 : 0;
      const removing = trash || (minus && qty <= 1);
      const rows = comp.querySelectorAll('.cart-items__table-row[data-key]:not(.cart-items__nested-line)');
      const isLast = rows.length === 1;

      if (removing) {
        if (trash) trash.classList.add('mr-spin');
        // Last line: the theme swaps to the empty state at once, so play our exit first, then hand over.
        if (isLast && !reduce() && typeof comp.onLineItemRemove === 'function' && lineOf(row)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          leaveThenRemove(comp, row, lineOf(row), trash);
        }
        return;
      }

      row.classList.add('mr-busy');
      setTimeout(() => row.classList.remove('mr-busy'), 6000); // safety net
    },
    true
  );
})();
